import axios from "axios";
import router from "./router";

let baseUrl = "https://3t2jdrbo8i.execute-api.ap-southeast-2.amazonaws.com/waves";
let host = window.location.host;
if (
  host == "localhost:8080" ||
  host == "localhost:8081" ||
  host == "localhost:8082"
) {
  baseUrl = "http://localhost:9080/waves";
} else if (host.substring(0, 4) == "dev.") {
  baseUrl = "https://api.dev.simplesoftware.nz/waves";
} else if (
  host.split(".")[0] == "training" ||
  host.split(".")[0] == "wavestraining"
) {
  baseUrl = "https://3t2jdrbo8i.execute-api.ap-southeast-2.amazonaws.com/waves_training";
  document.title = "Waves Training";
  changeFavicon(
    "https://nzsls.s3.ap-southeast-2.amazonaws.com/siteFiles/pinkLogo.ico"
  );
} else if (host == "10.0.0.141:9080") {
  baseUrl = "http://10.0.0.141:9080/waves";
} else if (host == "wavesapp.local") {
  baseUrl = "http://wavesapp.local:9080/waves";
}

function changeFavicon(src) {
  var link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  link.href = src;
}

let api = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    // if (
    //   response.data.hasOwnProperty("Result") &&
    //   response.data.Result == "No Internet"
    // ) {
    //   if (
    //     !router.currentRoute.meta.offlineAvailability &&
    //     router.currentRoute.name != null
    //   ) {
    //     router.push("/mobile-view/home");
    //   }
    // }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
